import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { Base_Url } from '../config';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');


  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [showForgotModal, setShowForgotModal] = useState(false);

    const handleShowChangePasswordModal = () => {
      setShowChangePasswordModal(true);
    };

    const handleCloseChangePasswordModal = () => {
      setShowChangePasswordModal(false);
    };
    const handleCloseForgotModal = () => {
      setShowForgotModal(false);
    };
    const handleShowForgotModal = () => {
      setShowForgotModal(true);
    };

  const navigateTo = useNavigate();

  // };
  const location = useLocation();

  // console.log(location.pathname)

  useEffect(() => {
    if (location.pathname === "/manage-csc-website") {
      handleLoginWithIITD();
    }
  }, [location.pathname]);


const handleLoginWithIITD =()=>{
  // window.location.href="https://oauth.iitd.ac.in/login.php?response_type=code&client_id=yfXGWAysgfgSOYmyT0xBGY7cKIRrv7OZ&state=xyz"

  // window.location.href="https://dos.iitd.ac.in/backend/a.php?response_type=code&client_id=yfXGWAysgfgSOYmyT0xBGY7cKIRrv7OZ&state=xyz"

  // window.location.href="api/admin-login/iitd"
  window.location.href=`${Base_Url}/admin-login/iitd`
  // window.location.href="https://dos.iitd.ac.in/api/admin-login/iitd"
  // window.location.href="https://oauth.iitd.ac.in/login.php?response_type=code&state=xyz&client_id=PmQgWttSKfN6MklT1kaewjU8zJsXY6lJ&state=xyz"

}

  return (
    <>
    <div className="grid">

      <div className="order__right centered no__overflow">
        <img
          className="img img-fluid h-100"
          src="https://home.iitd.ac.in/images/for-faculty/camp8.jpg"
          alt="picture"
          style={{width:"100%"}}
        />
      </div>
    </div>

      </>
  );
};

export default Login;